import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDots = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M9 6.75C9.9665 6.75 10.75 5.9665 10.75 5C10.75 4.0335 9.9665 3.25 9 3.25C8.0335 3.25 7.25 4.0335 7.25 5C7.25 5.9665 8.0335 6.75 9 6.75ZM9 13.75C9.9665 13.75 10.75 12.9665 10.75 12C10.75 11.0335 9.9665 10.25 9 10.25C8.0335 10.25 7.25 11.0335 7.25 12C7.25 12.9665 8.0335 13.75 9 13.75ZM10.75 19C10.75 19.9665 9.9665 20.75 9 20.75C8.0335 20.75 7.25 19.9665 7.25 19C7.25 18.0335 8.0335 17.25 9 17.25C9.9665 17.25 10.75 18.0335 10.75 19ZM15 6.75C15.9665 6.75 16.75 5.9665 16.75 5C16.75 4.0335 15.9665 3.25 15 3.25C14.0335 3.25 13.25 4.0335 13.25 5C13.25 5.9665 14.0335 6.75 15 6.75ZM16.75 12C16.75 12.9665 15.9665 13.75 15 13.75C14.0335 13.75 13.25 12.9665 13.25 12C13.25 11.0335 14.0335 10.25 15 10.25C15.9665 10.25 16.75 11.0335 16.75 12ZM15 20.75C15.9665 20.75 16.75 19.9665 16.75 19C16.75 18.0335 15.9665 17.25 15 17.25C14.0335 17.25 13.25 18.0335 13.25 19C13.25 19.9665 14.0335 20.75 15 20.75Z",
		fill: "currentcolor"
	})]
});
export default SvgDots;
